const GERMAN_TIMEZONE = 'Europe/Berlin';
const dateFormatter = new Intl.DateTimeFormat('de-DE', {
  weekday: 'short',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: GERMAN_TIMEZONE,
});
const dateFormatterWithoutWeekday = new Intl.DateTimeFormat('de-DE', {
  dateStyle: 'medium',
  timeZone: GERMAN_TIMEZONE,
});

// Di., 22.08.2024 or without weekday: 22.08.2024
const formatDate = (date?: Date | null, withoutWeekday?: boolean) => {
  if (date) {
    if (withoutWeekday) {
      return dateFormatterWithoutWeekday.format(date);
    }

    return dateFormatter.format(date);
  }

  return '-';
};

/*
 * Ranges
 */

// 22.08.2024 - 31.03.2026
export const formatDateRange = (start: Date, end: Date | null, withoutWeekday?: boolean) => {
  const formattedStart = formatDate(start, withoutWeekday);
  const formattedEnd = formatDate(end, withoutWeekday);

  if (formattedStart === formattedEnd) {
    return formattedStart;
  }

  return `${formattedStart} – ${end === null ? '∞' : formattedEnd}`;
};
